import type { ColumnsType, AnyObject } from "@similarweb/pro-logic-components";

import type { ITableOptions } from "app/pages/keyword-research/website-analysis/pages/website-keywords/enrichedTable/types";
import { EKeywordTabs } from "app/UtilitiesAndConstants/Constants/SourceTypes";

import {
    getIndexColumn,
    KEYWORD_COLUMN,
    getTopUrlColumn,
    getClicksShareColumn,
    CLICKS_CHANGE_COLUMN,
    ORGANIC_SHARE_COLUMN,
    VOLUME_COLUMN,
    ZERO_CLICKS_COLUMN,
    POSITION_COLUMN,
    POSITION_CHANGE_COLUMN,
    getSerpFeaturesColumn,
    applySorting,
} from "../sharedTableColumns";

const tableOptions: ITableOptions = {
    sitesForSerpColumn: [],
    onSerpIconClick: () => {},
    serpFeatureItemBackgroundColor: "",
};

export const getEnrichedKeywordsTableColumns = (
    currentPage: number,
    pageSize: number,
    selectedPageTab: string,
    sortConfig: { sort: string; asc: boolean },
    topUrlTargetState?: string,
): ColumnsType<AnyObject> => {
    const columns: ColumnsType<AnyObject> = [
        getIndexColumn(currentPage, pageSize),
        { ...KEYWORD_COLUMN },
        getClicksShareColumn(selectedPageTab),
        { ...CLICKS_CHANGE_COLUMN },
        ...(selectedPageTab === EKeywordTabs[EKeywordTabs.Total] ? [{ ...ORGANIC_SHARE_COLUMN }] : []),
        { ...VOLUME_COLUMN },
        { ...ZERO_CLICKS_COLUMN },
        { ...POSITION_COLUMN },
        { ...POSITION_CHANGE_COLUMN },
        getTopUrlColumn(topUrlTargetState),
        getSerpFeaturesColumn(tableOptions),
    ];

    return applySorting(columns, sortConfig);
};
